import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

const baseUrl = "/api/v1";


export interface ProductCategoriesParameter {
    productIds: string[];
    type: string;
}

export interface ProductCategoriesModel {
    id: string;
    erpNumber: string;
    categories: {
        item_category: string;
        item_category2: string;
        item_category3: string;
    };
    categoriesIds: {
        item_category: string;
        item_category2: string;
        item_category3: string;
    };
    brandName: string | null;
    customProperties: Record<string, unknown>;
    attributes: {
        [key: string]: string;
    };
}


export async function getProductCategories(
    params: ProductCategoriesParameter,
): Promise<ServiceResult<ProductCategoriesModel[]>> {
    try {
        const result = await post<{ productProperties: ProductCategoriesModel[] }>(
            `${baseUrl}/productproperties`,
            params as any,
        );

        return {
            result: result.productProperties,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getSystemList(parameter?: any): Promise<ServiceResult<any>> {
    const data = await get<any>(`${baseUrl}/customlist/restrictedCharacters`);

    return {
        successful: true,
        result: {
            systemList: data.List?.map((list: any) => ({
                description: list.Description,
                name: list.Name,
            })),
        },
    };
}